<template>
  <v-card class="half-radius shadow px-3 pb-10 pt-7" width="250">
    <v-row align="center" justify="space-between" class="px-5">
      <v-avatar class="shadow circle">
        <v-img height="30" contain src="@/assets/logo.png" alt="Arches Dev"></v-img>
      </v-avatar>
      <span class="body-1">Answer Key</span>
      <v-btn icon @click="showAnswers = !showAnswers">
        <v-icon
          size="30"
          v-text="showAnswers ? '$vuetify.icons.appVisible' : '$vuetify.icons.appInvisible'"
        ></v-icon>
      </v-btn>
    </v-row>
    <v-card-text>
      <v-slide-x-transition v-if="finished" group mode="out-in" hide-on-leave>
        <template v-if="showAnswers">
          <template v-for="(question, index) in questions">
            <!-- <span class="custom-text mb-1" v-if="addContent" :key="question.content + index">
              <span class="custom-text" v-if="addContent">{{index+1 + splitChar + ' '}}</span>
              {{question.content}}
            </span> -->
            <p :key="question.good_answer + index" class="mb-3 custom-text body-2">
              <span class="custom-text">{{ index + 1 + splitChar + " " }}</span>
              {{ question.good_answer }}
            </p>
          </template>
        </template>
        <template v-else>
          <p
            v-for="(question, index) in questions"
            :key="'Answers' + question.good_answer + index"
            v-text="index + 1 + splitChar + ' --------------'"
            class="mb-2 custom-text body-2"
          />
        </template>
      </v-slide-x-transition>
      <v-row v-else justify="center">
        <v-icon size="151" class="custom-icon">$vuetify.icons.appInvisible</v-icon>
        <v-col cols="12" class="text-center custom-text font-weight-light body-2">
          <span>You can check the answers only when you finish the exercise</span>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>
<script>
export default {
  props: {
    questions: {
      type: Array,
      required: true,
    },
    finished: {
      type: Boolean,
      required: true,
    },
    splitChar: {
      type: String,
      required: false,
      default: ".",
    },
    addContent: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      showAnswers: true,
    };
  },
};
</script>
<style scoped>
.custom-icon {
  width: 151px;
}
</style>
